import { render } from "./UpgradeSucceeded.vue?vue&type=template&id=67cfb61b"
import script from "./UpgradeSucceeded.vue?vue&type=script&lang=js"
export * from "./UpgradeSucceeded.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__